import { hasAnalyticsConsent } from '@/lib/cookie-consent';
import { GA4_EVENT_ALIASES } from './events';

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

let scriptLoaded = false;
let initAttempted = false;

function measurementId(): string | undefined {
  const id = (import.meta.env.VITE_GA_MEASUREMENT_ID as string | undefined)?.trim();
  return id || undefined;
}

function ensureGtag(): boolean {
  if (!hasAnalyticsConsent()) return false;
  const id = measurementId();
  if (!id || typeof window === 'undefined') return false;

  if (!window.dataLayer) window.dataLayer = [];
  if (!window.gtag) {
    window.gtag = function gtag(...args: unknown[]) {
      window.dataLayer?.push(args);
    };
  }

  if (!initAttempted) {
    initAttempted = true;
    window.gtag('js', new Date());
    window.gtag('config', id, { send_page_view: false });
  }

  if (!scriptLoaded) {
    scriptLoaded = true;
    const existing = document.querySelector(`script[data-ga4="${id}"]`);
    if (!existing) {
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`;
      script.dataset.ga4 = id;
      document.head.appendChild(script);
    }
  }

  return true;
}

/** Envia page_view ao GA4 (no-op sem Measurement ID). */
export function gaPageView(path: string, title?: string): void {
  if (!ensureGtag()) return;
  const id = measurementId();
  window.gtag?.('event', 'page_view', {
    page_path: path,
    page_title: title ?? document.title,
    send_to: id,
  });
}

/** Envia evento customizado ao GA4. */
export function gaEvent(name: string, params?: Record<string, unknown>): void {
  if (!ensureGtag()) return;
  const gaName = GA4_EVENT_ALIASES[name] ?? name;
  window.gtag?.('event', gaName, params ?? {});
}

export function isGaConfigured(): boolean {
  return Boolean(measurementId());
}
